<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')" :maxWidth="'400px'">
      <template v-slot:title> Настройки </template>
      <v-row>
        <v-col cols="12" class="pb-0">
          <a-form-model v-model="data" :model="model" :errors="errors" :config="{ dense: true }" @validate="validate($event)" />
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save @click="submit()" :title="'Сохранить'"></a-btn-save>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl } from "@/components/mixings";
export default {
  mixins: [getForm, submitForm, removeEl],

  props: {
    value: Boolean,
    model: [Object, Array],
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.fetchData();
  },
  watch: {
    value(v) {
      console.log("watch value", v);
      if (v) {
        this.fetchData();
      }
    },
  },
  methods: {
    fetchData() {
      for (const m of this.model) {
        if (this.$store.getters["config/getLocalParams"]?.[m.name]) this.$set(this.data, m.name, this.$store.getters["config/getLocalParams"]?.[m.name] || null);
      }
    },
    async submit() {
      let sendRefresh;
      for (let m of this.model) {
        this.$store.commit("config/setLocalParams", {
          name: m.name,
          value: this.data[m.name],
        });
        if (m.sendRefresh) sendRefresh = m.sendRefresh;
      }
      this.$emit("input");
      if (sendRefresh) {
        this.$store.commit("state/TRIGGER_REFRESH", sendRefresh);
      }
      return true;
    },
  },
};
</script>
